import { MeterType } from '@/models/meterType';
import api from '..';

const getMeterTypes = async () => {
  const baseUrl = process.env.VUE_APP_API_URL;
  const response = await api.get<MeterType>(`${baseUrl}/meter-types`);

  return response.data;
};

export default getMeterTypes;
